var map = {
	"./00_limit.json": "u2Il",
	"./01_connect.json": "uUP9",
	"./02_data_compress.json": "ku8a",
	"./03_heart_beat.json": "QDPd",
	"./04_subscribe.json": "f4mz",
	"./05_cancel_subscribe.json": "IhWV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Wd1J";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/websocket/introduce \.json$
// module id = Wd1J
// module chunks = 3